import { useEffect } from "react";
import { usePhase } from "../context/PhaseContext";
import { Seo } from "../components/Seo";
import { NoiseCursor } from "../components/NoiseCursor";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Ticker } from "../components/Ticker";
import { CinematicFilm } from "../components/CinematicFilm";
import { ArtOrigin } from "../components/ArtOrigin";
import { Gallery } from "../components/Gallery";
import { ChapterTeaser } from "../components/ChapterTeaser";
import { MaterialSystem } from "../components/MaterialSystem";
import { Shop } from "../components/Shop";
import { Fragrances } from "../components/Fragrances";
import { Vault } from "../components/Vault";
import { Objects } from "../components/Objects";
import { Manifesto } from "../components/Manifesto";
import { Mission } from "../components/Mission";
import { PackagingKit } from "../components/PackagingKit";
import { SocietyBlock } from "../components/SocietyBlock";
import { Waitlist } from "../components/Waitlist";
import { Footer } from "../components/Footer";
import { CartDrawer } from "../components/CartDrawer";

export default function Landing() {
  const { phase } = usePhase();
  const commerce = phase >= 5;

  const scrollToJoin = () => {
    const el = document.getElementById("join");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (window.location.hash) {
      const el = document.getElementById(window.location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, []);

  return (
    <>
      <Seo path="/" />
      <div className="bg-bds-bg text-bds-fg min-h-screen font-grotesk antialiased">
        <NoiseCursor />
        <Navbar onJoin={scrollToJoin} />
        <main>
          <Hero onJoin={scrollToJoin} />
          <Ticker />
          {!commerce && (
            <>
              <CinematicFilm />
              <ArtOrigin />
              <Gallery />
              <ChapterTeaser />
              {phase >= 2 && <MaterialSystem />}
            </>
          )}
          {commerce && (
            <>
              <Shop />
              <Fragrances />
              <Objects />
              <Vault />
              <Gallery />
            </>
          )}
          <Manifesto />
          <Mission />
          <SocietyBlock />
          {commerce && <PackagingKit />}
          <Waitlist />
        </main>
        <Footer onJoin={scrollToJoin} />
        {commerce && <CartDrawer />}
      </div>
    </>
  );
}
